export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/components/app-breadcrumbs/index.ts